import { render, staticRenderFns } from "./index-primary.vue?vue&type=template&id=64f04458&scoped=true&"
import script from "./index-primary.vue?vue&type=script&lang=js&"
export * from "./index-primary.vue?vue&type=script&lang=js&"
import style0 from "./index-primary.vue?vue&type=style&index=0&id=64f04458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f04458",
  null
  
)

export default component.exports